import { Component, type ErrorInfo, type ReactNode } from "react";

type Props = { children: ReactNode; scope?: "page" | "panel"; onClose?: () => void };
type State = { failed: boolean };

/** Keep recovery independent of providers and the router: either may have failed. */
export class RecoveryBoundary extends Component<Props, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch(_error: Error, _info: ErrorInfo) {
    // Render errors may contain App data. Do not send raw errors to telemetry.
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div role="alert" className="flex min-h-48 flex-1 flex-col items-center justify-center gap-4 bg-background p-6 text-center text-foreground">
        <h1 className="text-lg font-semibold">This {this.props.scope === "panel" ? "panel" : "page"} could not be displayed</h1>
        <p className="text-sm text-muted-foreground">You can return to My Apps or reload this page.</p>
        <div className="flex flex-wrap justify-center gap-3">
          {this.props.onClose && <button type="button" onClick={this.props.onClose} className="rounded border px-4 py-2">Close panel</button>}
          <a href="/applications" className="rounded border px-4 py-2">Back to My Apps</a>
          <button type="button" onClick={() => window.location.reload()} className="rounded border px-4 py-2">Reload page</button>
        </div>
      </div>
    );
  }
}
